import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { shouldShowToast } from "./apiError.util";
import { friendlyMessage } from "./friendlyMessage.util";

let suppressErrors = false;

export const beginSessionExpiry = () => {
	suppressErrors = true;
};

export const resumeErrorToasts = () => {
	suppressErrors = false;
};

const VARIANTS = {
	success: { icon: "\u2713", accent: "#16a34a", bg: "#f0fdf4", duration: 3500 },
	error: { icon: "!", accent: "#dc2626", bg: "#fef2f2", duration: 6000 },
};

function show(kind, rawMessage) {
	const v = VARIANTS[kind];
	const node = document.createElement("div");
	node.setAttribute("role", kind === "error" ? "alert" : "status");
	node.style.cssText = "display:flex;align-items:center;gap:10px;";
	const badge = document.createElement("span");
	badge.textContent = v.icon;
	badge.setAttribute("aria-hidden", "true");
	badge.style.cssText = `flex:none;width:22px;height:22px;border-radius:50%;background:${v.accent};color:#fff;font-weight:700;font-size:13px;display:flex;align-items:center;justify-content:center;`;
	const text = document.createElement("span");
	text.textContent = friendlyMessage(rawMessage, kind);
	node.append(badge, text);
	const toast = Toastify({
		node,
		duration: v.duration,
		close: true,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		style: {
			background: v.bg,
			color: "#1f2937",
			borderLeft: `4px solid ${v.accent}`,
			borderRadius: "10px",
			boxShadow: "0 8px 24px rgba(15,23,42,0.14)",
			padding: "12px 16px",
			fontSize: "14px",
			fontWeight: 500,
			maxWidth: "420px",
			display: "flex",
			alignItems: "center",
			gap: "12px",
		},
	});
	toast.showToast();
	// The library's close button is white at 40% opacity, which vanishes on this card.
	const close = toast.toastElement?.querySelector(".toast-close");
	if (close) close.style.cssText = "color:#1f2937;opacity:0.85;font-size:16px;padding:0 4px;";
}

export const successToastify = (msg) => {
	if (!msg) return;
	show("success", msg);
};

export const errorToastify = (msg, options = {}) => {
	if (!msg) return;
	if (suppressErrors && options.id !== "session-expired") return;
	if (!shouldShowToast(options.id || msg)) return;
	show("error", msg);
};
